var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleeperLadies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 18,
    viewBox: "0 0 52 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#979797",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M48.329.375h-44.6c-.719 0-1.374.295-1.85.771a2.616 2.616 0 00-.769 1.852v15.086c0 .721.294 1.378.77 1.853.473.475 1.127.77 1.85.77h44.6c.719 0 1.374-.295 1.85-.772a2.61 2.61 0 00.769-1.851V2.998c0-.722-.294-1.378-.77-1.854a2.606 2.606 0 00-1.85-.769z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA3988",
    d: "M42.98 2.68h2.385a1.628 1.628 0 011.631 1.628v12.465c0 .453-.18.86-.475 1.153a1.63 1.63 0 01-1.156.475H42.98a1.623 1.623 0 01-1.631-1.628V4.308c0-.453.18-.859.474-1.152a1.632 1.632 0 011.157-.476z"
  }))));
}
export default SvgSleeperLadies;